import { FC, ReactNode } from "react";
import { Flex, VStack } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";

interface Props {
  leftContent: ReactNode;
  rightContent: ReactNode;
  leftBgColor?: string;
  rightBgColor?: string;
}

export const TwoPanelLayout: FC<Props> = ({
  leftContent,
  rightContent,
  leftBgColor = "#FFF0B1",
  rightBgColor = "th.cream1",
}) => {
  return (
    <FullBleedSection bg={rightBgColor} flexGrow={1} justify="flex-start">
      <Flex flexGrow={1} w="full" direction={{ base: "column", lg: "row" }}>
        {/* Left Column - Desktop Only */}
        <Flex w="full" display={{ base: "none", lg: "flex" }}>
          <Flex justify="center" overflow="hidden" w="full" bg={leftBgColor}>
            <Flex
              direction="column"
              gap={6}
              pt={{ base: 8, lg: 16 }}
              pb={{ base: 8, lg: 16 }}
              px={{ base: 6, lg: 12 }}
              w="full"
              maxW="40rem"
            >
              <VStack alignItems="flex-start" spacing={6}>
                {leftContent}
              </VStack>
            </Flex>
          </Flex>
        </Flex>

        {/* Right Column */}
        <Flex w="full">
          <Flex justify="center" overflow="hidden" w="full" bg={{ base: leftBgColor, lg: rightBgColor }}>
            <VStack
              direction="column"
              gap={6}
              pt={{ base: 8, lg: 16 }}
              pb={{ base: 8, lg: 16 }}
              px={{ base: 6, lg: 12 }}
              w="full"
              maxW="40rem"
              alignItems="flex-start"
              spacing={6}
            >
              {/* Mobile hero content */}
              <VStack
                display={{ base: "flex", lg: "none" }}
                alignItems="flex-start"
                spacing={6}
                mb={6}
                w="full"
              >
                {leftContent}
              </VStack>
              
              {rightContent}
            </VStack>
          </Flex>
        </Flex>
      </Flex>
    </FullBleedSection>
  );
};